export const STATIC_ASSETS_PLACEHOLDER = "STATIC_ASSETS_BASE_URL";
export const staticAssetsReplacementRegex = new RegExp(STATIC_ASSETS_PLACEHOLDER, "g");
